<template>
	<div>
		<section
			class="section pb-0 section-components"
		>
			<div
				class="mb-5 container-fluid text-center"
			>
				<!-- Inputs -->
				<h1 id="contacto_anchor" class="mb-4" style="color: #000">
					<b>Contacto</b>
				</h1>
				<div class="mt-4 container">
					<b style="color: #000">
						Déjanos tu mensaje y dinos cómo podemos ayudarte.
					</b>
				</div>
				<form
					id="app"
					@submit="checkForm"
					method="post"
					novalidate="true"
					enctype="multipart/form-data"
				>
                    <div class="container">
					<div class="row justify-content-center">
						<div
							class="card shadow-sm mt-5 col-12 col-md-12 col-lg-6"
							style="border: 2px solid #ee2a32"
						>
							<div class="card-body">
								<b-alert v-model="errorContacto" variant="danger" class="mb-3">
									Ocurrio un problema enviando tu correo.
								</b-alert>
								<b-alert v-model="successContacto" variant="success" class="mb-3">
									<h4 class="alert-heading">Estimado Usuario Trivia Mobil™ F1.</h4>
									<p>
										Recibimos su mensaje. En un lapso máximo de 72 horas recibirá respuesta.
									</p>
									<hr class="my-2">
									<p class="mb-0">
										Quedamos a sus ordenes.
									</p>
								</b-alert>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="full_name"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Nombre:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="full_name"
												name="full_name"
												v-model="formTicket.full_name"
												placeholder="Nombre(s) y Apellidos"
												value=""
												required
											/>
											<small class="help-block" v-if="errorNombre"
												>El nombre es obligatorio</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="email"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Email:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="email"
												name="email"
												v-model="formTicket.email"
												placeholder="Email"
												value=""
												required
											/>
											<small class="help-block" v-if="errorCorreo"
												>El correo es obligatorio</small
											>
											<small class="help-block" v-if="errorCorreoValido"
												>El correo no es valido</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="asunto"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Asunto:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												id="asunto"
												name="asunto"
												v-model="formTicket.asunto"
												placeholder="Asunto"
												value=""
												required
											/>
											<small class="help-block" v-if="errorAsunto"
												>El asunto es obligatorio</small
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-lg-3 text-left">
										<label
											for="mensaje"
											style="color: #000"
											class="mt-2"
											v-if="!isMobile"
											>Mensaje:</label
										>
									</div>
									<div class="col-lg-9 text-left">
										<div class="form-group">
											<textarea
												placeholder="Mensaje"
												class="form-control"
												name="mensaje"
												id="mensaje"
												v-model="formTicket.mensaje"
												required
											></textarea>
											<small class="help-block" v-if="errorMensaje"
												>El mensaje es obligatorio</small
											>
										</div>
									</div>
								</div>
								<!-- <small class="text-danger">{{errorImgs}}</small> <br>
                                <small class="text-danger">{{errorArchivo}}</small> <br> -->
							</div>
						</div>
					</div>
                    </div>
					<div class="row justify-content-center">
						<div class="col-md-12">
							<button
								style="background: #007bff"
								type="submit"
								class="btn btn-primary p-1 mt-5 mb-4 pl-5 pr-5"
								id="enviar"
							>
								Enviar
								<b-spinner small v-if="loader"></b-spinner>
							</button>
						</div>
						<div class="col-md-3 mt-45">
							<hr style="border-top: 2px solid #f5f5f5 !important" />
						</div>
					</div>
				</form>
			</div>
		</section>
	</div>
</template>
<script>
import axios from "axios";
export default {
	components: {
		
	},
	data() {
		return {
			errors: [],
			errorNombre: false,
			errorCorreo: false,
			errorCorreoValido: false,
			errorAsunto: false,
			errorMensaje: false,
			formTicket: {
				full_name: null,
				email: null,
				asunto: null,
				mensaje: null,
			},
			loader: false,
			isMobile: this.$mobile(),
			successContacto: false,
			errorContacto: false,
		};
	},
	methods: {
		checkForm: function (e) {
			e.preventDefault();
			this.errors = [];
			this.errorNombre = false;
			this.errorCorreo = false;
			this.errorCorreoValido = false;
			this.errorAsunto = false;
			this.errorMensaje = false;
			this.successContacto = false;
			this.errorContacto = false;
			if (!this.formTicket.full_name) {
				this.errorNombre = true;
				this.errors.push("El nombre es obligatoria.");
			}
			if (!this.formTicket.email) {
				this.errorCorreo = true;
				this.errors.push("El correo electrónico es obligatorio.");
			} else if (!this.validEmail(this.formTicket.email)) {
				this.errorCorreoValido = true;
				this.errors.push("El correo electrónico debe ser válido.");
			}
			if (!this.formTicket.asunto) {
				this.errorAsunto = true;
				this.errors.push("El asunto es obligatoria.");
			}
			if (!this.formTicket.mensaje) {
				this.errorMensaje = true;
				this.errors.push("El mensaje es obligatoria.");
			}
			if (!this.errors.length) {
				this.loader = true;
				// Acción si todo esta correcto
				// axios.get("http://127.0.0.1:8000/api/api_save_customer").then((rest) => {

				// });
				let model = this.prepareModel();

				axios
					.post("https://api.mobilracing.mx/api/contacto", model)
					.then(({ data }) => {
						this.successContacto = true;
						this.formTicket.email = null;
						this.formTicket.full_name = null;
						this.formTicket.asunto = null;
						this.formTicket.mensaje = null;
						this.loader = false;
					})
					.catch((err) => {
						this.errorContacto = true;
						this.loader = false;
					});
			}
		},
		prepareModel() {
			var model = new FormData();
			model.append("email", this.formTicket.email);
			model.append("nombre", this.formTicket.full_name);
			model.append("asunto", this.formTicket.asunto);
			model.append("mensaje", this.formTicket.mensaje);

			return model;
		},
		validEmail: function (email) {
			var re =
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		validPhone: function (phone) {
			var re = /^[0-9]{1}[0-9]{9}$/;
			return re.test(phone);
		},
	},
	// mounted(){},
};
</script>
<style>
input[type="file"] {
	display: none;
}
.custom-file-upload {
	border: 1px solid #ccc;
	display: inline-block;
	padding: 6px 12px;
	cursor: pointer;
}
.help-block {
	color: red;
	text-align: left;
}

#checkImage2 {
	width: 11% !important;
}
</style>